import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="container-x pt-24">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600">
        {items.map((item, idx) => (
          <li key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
            {idx > 0 && <i className="ri-arrow-right-s-line text-foreground-300" />}
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span aria-current="page" className="text-foreground-950">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}